//src/hooks/useMouseParallax.ts
import { useEffect } from "react";
import { useMotionValue, useSpring, useTransform } from "framer-motion";

export const useMouseParallax = (isMobile: boolean) => {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const smoothX = useSpring(mouseX, { damping: 20, stiffness: 150 });
  const smoothY = useSpring(mouseY, { damping: 20, stiffness: 150 });

  const transforms = {
    gold: {
      x: useTransform(smoothX, [-0.5, 0.5], ["-15%", "15%"]),
      y: useTransform(smoothY, [-0.5, 0.5], ["-10%", "10%"]),
    },
    rose: {
      x: useTransform(smoothX, [-0.5, 0.5], ["10%", "-10%"]),
      y: useTransform(smoothY, [-0.5, 0.5], ["15%", "-15%"]),
    },
    blue: {
      x: useTransform(smoothX, [-0.5, 0.5], ["-5%", "5%"]),
      y: useTransform(smoothY, [-0.5, 0.5], ["5%", "-5%"]),
    },
  };

  useEffect(() => {
    if (isMobile) return;

    const handleMouseMove = (e: MouseEvent) => {
      mouseX.set(e.clientX / window.innerWidth - 0.5);
      mouseY.set(e.clientY / window.innerHeight - 0.5);
    };

    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [isMobile, mouseX, mouseY]);

  return transforms;
};
